import standardFeatures from './standardFeatures';

const root = {
	standardFeatures
};

export default root;
